import { useState, useCallback, useMemo } from 'react';

export const useSearch = (data, searchFields = ['name']) => {
  const [searchTerm, setSearchTerm] = useState('');

  // Filter data based on search term
  const filteredData = useMemo(() => {
    if (!searchTerm || !data || !Array.isArray(data)) {
      return data || [];
    }

    const lowerSearchTerm = searchTerm.toLowerCase();

    return data.filter((item) => {
      return searchFields.some((field) => {
        const fieldValue = item[field];
        if (typeof fieldValue === 'string') {
          return fieldValue.toLowerCase().includes(lowerSearchTerm);
        }
        return false;
      });
    });
  }, [data, searchTerm, searchFields]);

  // Update search term
  const updateSearchTerm = useCallback((newTerm) => {
    setSearchTerm(newTerm);
  }, []);

  // Clear search
  const clearSearch = useCallback(() => {
    setSearchTerm('');
  }, []);

  // Check if search is active
  const isSearchActive = useMemo(() => {
    return searchTerm.length > 0;
  }, [searchTerm]);

  // Get search result count
  const searchResultCount = useMemo(() => {
    return filteredData.length;
  }, [filteredData]);

  return {
    searchTerm,
    filteredData,
    updateSearchTerm,
    clearSearch,
    isSearchActive,
    searchResultCount
  };
};

// Specialized search hooks for different data types
export const useAdvertiserSearch = (advertisers, searchFields = ['name', 'org_name']) => {
  return useSearch(advertisers, searchFields);
};

export const useOrganizationSearch = (organizations) => {
  return useSearch(organizations, ['name']);
};
